import type { DateTime } from "luxon";
import { getShiftTypeFromStartTime } from "../../utils/dateUtils";
import type { OvertimeKind } from "../../utils/models";
import type { CompositionLine } from "./wageComposition";

/**
 * The engine names a segment after whichever hours-rate rule it cut on ("NightRN", "NightRN Weekly OT"),
 * and a rule's name is free text. The panel header stays the shift window — Day, Night, Holiday — plus the
 * overtime kind, read from the segment's own lines rather than from that name: a rule called "Holiday
 * bonus" must not make an ordinary Day segment read "Holiday".
 */
const OT_SUFFIX: Readonly<Record<OvertimeKind, string>> = { daily: " Daily OT", weekly: " Weekly OT", consecutive: " Consecutive OT" };

export const generalSegmentLabel = (lines: CompositionLine[], startTime: DateTime): string => {
	const overtime = lines.find((line) => line.type === "overtime");
	const suffix = overtime ? OT_SUFFIX[overtime.contribution.otKind] : "";
	if (lines.some((line) => line.type === "holiday")) return `Holiday${suffix}`;
	return `${getShiftTypeFromStartTime(startTime)}${suffix}`;
};
